import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
  },
  scales: {
    xAxes: [
      {
        maxBarThickness: 40,
      },
    ],
    x: {
      grid: {
        display: false,
      },
    },
    y: {
      grid: {
        borderDash: [4],
      },
    },
  },
};

// ["Vacancies", "Projects", "Activities"];
const labels = ["", "", ""];

export default function SingleBarChart(props) {
  const data = {
    labels,
    datasets: [
      {
        label: "",
        data: labels.map((Item, i) => props.Data[i]),
        backgroundColor: "#6DA2F2",
        borderRadius: 4,
        barThickness: 40,
      },
    ],
  };
  return (
    <Bar
      options={options}
      data={data}
      style={{ position: "absolute", bottom: "24px" }}
    />
  );
}
